import { Path } from "app/path";
import {
  blacklistFromAccount,
  selectAccount,
  unblackListFromAccount,
} from "app/redux/accountSlice";
import {archiveClient, createClient, getClients, selectClients, updateClient} from "app/redux/clientsSlice";
import { selectActiveEmployees } from "app/redux/employeesSlice";
import { useQuery } from "app/utils/useQuery";
import { includes } from "lodash";
import * as React from "react";
import {FormEvent, useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {getFormValues} from "../utils/getFormValues";

export const perPageList = [10, 20, 50];
export const sortByList = [
  { title: "Recent", value: "updatedAt" },
  { title: "Name", value: "name" },
  { title: "Email", value: "email" },
];

export const useManageClients = () => {

  const {
    clients,
    meta: { totalCount },
  } = useSelector(selectClients);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const query = useQuery();
  const account = useSelector(selectAccount);
  const employees = useSelector(selectActiveEmployees);
  const pageParam = query.get("page");
  const clientIdParam = query.get("clientId");
  const managerIdsToFilterParam = query.get("managerIdsToFilter");
  const [rowsPerPage, setRowsPerPage] = useState(perPageList[0]);
  const [sortBy, setSortBy] = useState(sortByList[0]);
  const [shouldShowClientDrawer, setShouldShowClientDrawer] = useState(false);
  const [shouldShowBlacklistDrawer, setShouldShowBlacklistDrawer] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [managerIdsToFilter, setManagerIdsToFilter] = useState<number[]>(
    managerIdsToFilterParam?.split(",").map(Number) || []
  );


  const [isArchivingClient, setIsArchivingClient] = useState<boolean>(false)
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
  const [isCreatingClient, setIsCreatingClient] = useState(false);
  const [profileImagePreview, setProfileImagePreview] = useState<string | null>(
      null
  );
  const [profileImageFile, setProfileImageFile] = useState<File | null>(null);
  const [showViewModal, setShowViewModal] = useState<boolean>(false)
  const [selectedClient, setSelectedClient] = useState<any>(null)
  const [newClient, setNewClient] = useState<Partial<any>>({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    street: '',
    city: '',
    state: '',
    zipCode: '',
    birthday: '',
    notes: ''
  });

  const  handleAddClient= () => {

  }
  const formatCurrency = (amount: number) => {
    return `$${amount?.toLocaleString()}`;
  };


  const [editMode, setEditMode] = useState(false);
  const [editingClient, setEditingClient] = useState<any | null>(null);




  //
  // const onUserUpdate = async ({
  //                               key,
  //                               value,
  //                             }: {
  //   key: string;
  //   value: string | number[];
  // }) => {
  //   setEditingClient(true);
  //
  //   let finalKey = key;
  //   let finalValue = value;
  //   if (key === "firstName") {
  //     finalKey = "name";
  //     finalValue = `${value} ${selectedClient!.name.split(" ")[1]}`;
  //   } else if (key === "lastName") {
  //     finalKey = "name";
  //     finalValue = `${selectedClient!.name.split(" ")[0]} ${value}`;
  //   }
  //
  //   if (key === "phone" && finalValue === "") {
  //     toast.error("A phone number is required");
  //     setEditingClient(false);
  //     return;
  //   }
  //
  //   try {
  //     await dispatch(
  //         updateClient({
  //           id: selectedClient!.id,
  //           [finalKey]: finalValue,
  //         } as any) as any
  //     ).unwrap();
  //
  //     // if (profileImageFile) {
  //     //   await handleAvatarUpload(client!.id); // Handle avatar upload after updating client
  //     // }
  //
  //     setEditingClient(false);
  //     toast.success("Client updated successfully");
  //   } catch (error) {
  //     setEditingClient(false);
  //     console.error(error);
  //     toast.error("Failed to update client");
  //   }
  // };


  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // setIsCreatingClient(true);
    const { firstName, lastName, email, phone, gender, notes,dob,address } = getFormValues(
        event.target as HTMLFormElement
    );

    if (phone === "") {
      toast.error("Phone is required");
      setEditMode(false);
      return;
    }

    const payload = {
      name: `${firstName} ${lastName}`,
      email,
      phone,
      gender,
      notes,
      dob,address
      // managerIds: managerIdsWhenCreating,
    };

    try {
      const client = await dispatch(createClient(payload) as any).unwrap();

      // if (profileImageFile) {
      //   await handleAvatarUpload(client.id); // Handle avatar upload after creating client
      // }

      // setIsCreatingClient(false);
      // setCloseParent?.(false);
      toast.success("Client created successfully");
    } catch (error) {
      // setIsCreatingClient(false);
      console.error(error);
      toast.error("Failed to create client");
    }}


  const onArchiveClient = async (clientToBeDeletedId: number) => {
    try {
      setIsArchivingClient(true);
      await dispatch(archiveClient(clientToBeDeletedId) as any).unwrap();
      toast.success("Client deleted successfully");
    } catch (error) {
      console.error(error);
      toast.error("Failed to deleted client");
    } finally {
      setIsArchivingClient(false);
      setShowDeleteModal(false);
      // setCloseParent?.(true);
      query.delete("clientId");
      navigate(Path.CLIENTS);
    }
  };
  const onUserUpdate = async (editingClient: any) => {
    try {
      const { id, firstName, lastName, ...rest } = editingClient;

      const payload: any = {
        ...rest,
        name: `${firstName} ${lastName}`.trim(),
      };

      // if (notes) {
      //   payload.notes_attributes = notes
      //       .split("\n")
      //       .filter((n: string) => n.trim() !== "")
      //       .map((n: string) => ({ content: n.trim() }));
      // }

      // remove null/undefined
      Object.keys(payload).forEach((k) => {
        if (payload[k] === null || payload[k] === undefined) {
          delete payload[k];
        }
      });

      await dispatch(updateClient({ id, ...payload }) as any).unwrap();

      toast.success("Client updated successfully");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update client");
    }
  };


  // inside useManageClients / useClientDrawer
  const updateClientBulk = async (editingClient: any) => {
    if (!editingClient || !editingClient.id) return;

    // setIsCreatingClient(true);

    try {
      const { id, firstName, lastName, ...rest } = editingClient;

      // Build payload
      const payload: any = {
        ...rest,
        name: `${(firstName || "").trim()} ${(lastName || "").trim()}`.trim(),
      };

      // managers may be provided as list of ids (managerIds) or as managers array
      // if (managerIds && Array.isArray(managerIds)) {
      //   payload.managerIds = managerIds;
      // } else if (managers && Array.isArray(managers)) {
      //   payload.managerIds = managers.map((m: any) => m.id);
      // }

      // notes -> notes_attributes for backend if present
      // if (typeof notes === "string") {
      //   const noteLines = notes
      //       .split("\n")
      //       .map((l) => l.trim())
      //       .filter(Boolean);
      //
      //   if (noteLines.length) {
      //     payload.notes_attributes = noteLines.map((content: string) => ({ content }));
      //   } else {
      //     // if you want to explicitly clear notes, you can set notes_attributes to []
      //     // else leave it out so we don't overwrite existing notes
      //   }
      // }

      // strip null/undefined
      Object.keys(payload).forEach((k) => {
        if (payload[k] === null || payload[k] === undefined || payload[k] === "") {
          delete payload[k];
        }
      });

      // Dispatch update; keep the same shape your existing updateClient expects
      // (previous single-field used: dispatch(updateClient({ id: clientId, [field]: value })))
      await dispatch(updateClient({ id, ...payload }) as any).unwrap();

      // If a new avatar file was selected, upload it AFTER updating client (same flow as before)
      // if (profileImageFile) {
      //   await handleAvatarUpload(id); // handleAvatarUpload already accepts (clientId, file?) in your earlier code
      // }

      toast.success("Client updated successfully");
    } catch (error) {
      console.error("Failed updating client (bulk):", error);
      toast.error("Failed to update client");
    } finally {
      // setIsCreatingClient(false);
    }
  };





  const handleAvatarUpload = async (clientId?: number, file?: any) => {
    const imageFileToUser = file || profileImageFile;

    if (clientId && imageFileToUser) {
      const formData = new FormData();
      formData.append("client[avatar]", imageFileToUser);

      try {
        await dispatch(
            updateClient({
              id: clientId,
              avatar: imageFileToUser,
            }) as any
        ).unwrap();
        toast.success("Profile image updated successfully");
      } catch (error: any) {
        console.error(
            "Error updating profile image:",
            error.response || error.message || error
        );
        toast.error("Failed to update profile image");
      }
    }
  };

  const handleProfileImageChange = async (
      event: React.ChangeEvent<HTMLInputElement>,
      submitNow = false
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfileImagePreview(imageUrl);
      setProfileImageFile(file); // Store the file in state
    }
    if (submitNow) {
      await handleAvatarUpload(selectedClient?.id, file);
    }
  };





  const handleCancelEdit = () => {
    if (selectedClient) {

      setEditingClient({...selectedClient});
      setEditMode(false);
    }
  };
  const getClientVisits = (clientId: number) => {
    // return visits.filter(v => v.clientId === clientId);
  };

  const handleViewClient = (client: any) => {
    setSelectedClient(client);
    setEditingClient({...client});
    setEditMode(false);
    setShowViewModal(true);
  };
  const handleCloseViewClient = () => {
    setSelectedClient(null);
    setEditingClient(null);
    setEditMode(false);
    setShowViewModal(false);

  };



  const fetchClients = async (payload?: any) => {
    setLoading(true);
    try {
      await dispatch(
        getClients({
          perPage: rowsPerPage,
          sortBy: sortBy.value,
          page: Number(pageParam) || 1,
          sortOrder: sortBy.value === "createdAt" ? "asc" : "desc",
          managerIds: managerIdsToFilter,
          search: query.get("search") || "", // Sync with URL search if used
          ...payload,
        }) as any
      ).unwrap();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onClientRowClick = (id?: number) => {
    setShouldShowClientDrawer(true);
    query.delete("clientId");
    query.set("clientId", id!.toString());
    navigate(`${Path.CLIENTS}?${query.toString()}`);
  };

  const onOpenNewClientDrawer = () => {
    query.delete("clientId");
    navigate(`${Path.CLIENTS}?${query.toString()}`);
    if (!shouldShowClientDrawer) {
      setShouldShowClientDrawer(true);
    }
  };

  const onBlacklistAdd = async (
    identifier: string,
    identifierType?: string
  ) => {
    try {
      await dispatch(
        blacklistFromAccount({
          identifier: identifier.toLowerCase(),
          identifierType: identifierType || "email",
        }) as any
      ).unwrap();
      toast.success(`${identifier} blacklisted successfully`);
    } catch (error: any) {
      if (
        includes(error?.data?.details?.identifier, "has already been taken")
      ) {
        toast.error(`${identifier} is already blacklisted`);
        return;
      }
      console.error(error);
    }
  };

  const onBlacklistRemove = async (
    identifier: string,
    identifierType?: string
  ) => {
    try {
      await dispatch(
        unblackListFromAccount({
          identifier,
          identifierType: "email",
        }) as any
      ).unwrap();
      toast.success(`${identifier} has been unblacklisted successfully`);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    (async () => {
      await fetchClients();
    })();
  }, [rowsPerPage, sortBy, pageParam, managerIdsToFilter, query.get("search")]);

  useEffect(() => {
    (async () => {
      const areManagerIdsToFilter = managerIdsToFilter.length > 0;

      if (areManagerIdsToFilter) {
        query.set("managerIdsToFilter", managerIdsToFilter.join(","));
      } else {
        query.delete("managerIdsToFilter");
      }
      navigate(`${Path.CLIENTS}?${query.toString()}`);

      if (managerIdsToFilterParam || areManagerIdsToFilter) {
        query.set("page", "1");
        await fetchClients({ page: 1 });
      }
    })();
  }, [managerIdsToFilter]);

  useEffect(() => {
    if (!shouldShowClientDrawer) {
      query.delete("clientId");
      navigate(`${Path.CLIENTS}?${query.toString()}`);
      setShouldShowClientDrawer(false);
    }
  }, [shouldShowClientDrawer]);

  return {

    newClient,
    setNewClient,
    handleAddClient,
    selectedClient,
    setSelectedClient,
    setShowViewModal,
    showViewModal,
    formatCurrency,
    handleCancelEdit,
    setEditMode,
    editMode,
    editingClient,
    setEditingClient,
    getClientVisits,
    handleViewClient,
    handleCloseViewClient,
    onUserUpdate,
    onSubmit,
    isArchivingClient,
    setIsArchivingClient,
    showDeleteModal,
    setShowDeleteModal,
    onArchiveClient,
    updateClientBulk,
    isCreatingClient,
    setIsCreatingClient,
    profileImagePreview,
    setProfileImagePreview,
    profileImageFile,
    setProfileImageFile,
    handleAvatarUpload,
    handleProfileImageChange,




    clients,
    rowsPerPage,
    setRowsPerPage,
    perPageList,
    sortBy,
    setSortBy,
    shouldShowClientDrawer,
    setShouldShowClientDrawer,
    onClientRowClick,
    clientIdParam,
    onOpenNewClientDrawer,
    loading,
    totalCount,
    shouldShowBlacklistDrawer,
    setShouldShowBlacklistDrawer,
    onBlacklistAdd,
    onBlacklistRemove,
    account,
    navigate,
    employees,
    managerIdsToFilter,
    setManagerIdsToFilter,
    fetchClients,
  };
};
